var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobileSidebarHolder positionRight",class:{'active': _vm.isSidebarActive}},[_c('div',{staticClass:"mobileSidebarHide",on:{"click":_vm.hideSidebar}}),_vm._v(" "),_c('div',{staticClass:"mobileSidebar"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }